import React, { useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Selection,
  Scrolling,
  LoadPanel,
  SearchPanel,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnChooserSelection,
  Position,
  MasterDetail,
  Format,
  Pager,
  Paging,  Button,
} from "devextreme-react/data-grid";
import Switch from "devextreme-react/switch";
import Guid from "devextreme/core/guid";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import "whatwg-fetch";
import { useStyles } from "../../Styles.js";
import { createStore } from "devextreme-aspnet-data-nojquery";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { api_path } from "../../shared.js";
import Select from "react-select";
import axios from "axios";
import dateFormat, { masks } from "dateformat";
export function UserDataGrid() {
  const classes = useStyles();
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  const [origin, setOrigin] = useState([]);
  const [originList, setOriginList] = useState([]);
  const [selectOrigin, setSelectOrigin] = useState([]);
  const [pod, setPod] = useState([]);
  const [podList, setPodList] = useState([]);
  const [selectPod, setSelectPod] = useState([]);
  const [delivery, setDelivery] = useState([]);
  const [deliveryList, setDeliveryList] = useState([]);
  const [selectDelivery, setSelectDelivery] = useState([]);
  const [etd, setEtd] = useState(now);
  const [getTotalCount, setTotalCount] = useState();
  const [getDateStr, setDateStr] = useState();
  const pageSizes = [50, 100];
  const handleSearch = (e) => {
    console.log("" + origin);
    console.log("" + selectPod);
    console.log("" + selectDelivery);
    console.log("" + etd);
  };

  const url = api_path + "/MS_USER_PROFILE.php";
  const dataSource = createStore({
    key: "CRM_UID",
    loadUrl: `${url}`,
  });
  const columnChooserModes = [
    {
      key: "dragAndDrop",
      name: "Drag and drop",
    },
    {
      key: "select",
      name: "Select",
    },
  ];
  const searchEditorOptions = { placeholder: "Search column" };
  const columnChooserModeLabel = { "aria-label": "Column Chooser Mode" };
  const cellPrepared = (e) => {
    // console.log(e.component.totalCount());
    setTotalCount(e.component.totalCount());
    if (e.rowType === "data") {
      if (e.column.dataField === "VALID" && e.data.VALID === "Valid") {
        e.cellElement.style.cssText = "color: #9ACD32;font-weight:bold;";
      } else if (e.column.dataField === "VALID" && e.data.VALID === "Invalid") {
        e.cellElement.style.cssText = "color: #ff6f4a;font-weight:bold;";
      }
    }
  };
  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          "CostSheet.xlsx"
        );
      });
    });
  };
  //Column Chooser
  const [mode, setMode] = React.useState(columnChooserModes[1].key);
  const [searchEnabled, setSearchEnabled] = React.useState(true);
  const [allowSelectAll, setAllowSelectAll] = React.useState(true);
  const [selectByClick, setSelectByClick] = React.useState(true);
  const [recursive, setRecursive] = React.useState(true);
  const isDragMode = mode === columnChooserModes[0].key;
  const onModeValueChanged = React.useCallback((e) => {
    setMode(e.value);
  }, []);
  const onSearchEnabledValueChanged = React.useCallback((e) => {
    setSearchEnabled(e.value);
  }, []);
  const onAllowSelectAllValueChanged = React.useCallback((e) => {
    setAllowSelectAll(e.value);
  }, []);
  const onSelectByClickValueChanged = React.useCallback((e) => {
    setSelectByClick(e.value);
  }, []);
  const onRecursiveValueChanged = React.useCallback((e) => {
    setRecursive(e.value);
  }, []);
  //end column chooser

  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
      // style: "currency",
      // currency: "USD",
    }).format(value);
  const jsonDataType = {
    options: [
      {
        value: "1",
        label: "Option 1",
      },
      {
        value: "2",
        label: "Option 2",
      },
      {
        value: "3",
        label: "Option 3",
      },
    ],
  };
    const onEditButtonClick = React.useCallback((e) => {
      const key = new Guid().toString();
      const dataRow = e.row && e.row.data;
      window.open("/s-crm/UserForm?crmid=" + e.row.key, "_blank");
    }, []);
    const handleToggle = (id, value) => {
  const newStatus = value ? 1 : 0;

  fetch(api_path + "/UPDATE_STATUS.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ID: id,
      IS_ACTIVE: newStatus,
    }),
  });
};
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <label className="head">User</label>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <div className="headLabel">
            Found {numberFormat(getTotalCount)} items {getDateStr}
          </div>
        </Grid>
        <Grid item xs={12} sm={3}>
          &nbsp;
        </Grid>
        <Grid item xs={12} sm={3}>
          {/* <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={handleClearInputClick}
          >
            Clear Filter
          </Button> */}
        </Grid>
      </Grid>
      <br />
      <Grid container className={classes.root}>
        <br />

        <DataGrid
          dataSource={dataSource}
          showBorders={true}
          columnAutoWidth={true}
          rowAlternationEnabled={true}
          showScrollbar={true}
          keyExpr="CRM_UID"
          onExporting={onExporting}
          width="100%"
        >
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible={true} />
          <Selection mode="single" />
          <SearchPanel
            visible={true}
            width={240}
            placeholder="Full Text Search..."
          />
          <Column dataField="CRM_UID" caption="ID" allowHiding={false} />
          <Column dataField="USER_EMAIL" caption="EMAIL" allowHiding={false} />
          <Column
            dataField="USER_FIRSTNAME"
            caption="FIRSTNAME"
            allowHiding={false}
          />
          <Column
            dataField="USER_LASTNAME"
            caption="LASTNAME"
          />
          <Column
            dataField="USER_NICKNAME"
            caption="NICKNAME"
          />
          <Column dataField="USER_TEL" caption="TEL" allowHiding={false} />
          <Column
            dataField="ROLE_NAME"
            caption="ROLE"
          />
          <Column
            dataField="USER_STATUS"
            caption="STATUS"
          />
          <Column dataField="EMP_CODE" caption="EMP CODE" allowHiding={false} />
          <Column
            dataField="ORIGIN_COUNTRY"
            caption="COUNTRY"
          />
          {/* <Column
  dataField="IS_ACTIVE"
  caption="Status"
  alignment="center"
  cellRender={(cellData) => (
    <Switch
      value={cellData.value === 1}
      onValueChanged={(e) =>
        handleToggle(cellData.data.ID, e.value)
      }
    />
  )}
/> */}

           <Column type="buttons">
            <Button
              icon="edit"
              onClick={onEditButtonClick}
              hint="Edit"
              //visible={isEditIconVisible}
            />
          </Column>
          <ColumnChooser enabled={true} mode={mode}>
            <Position
              my="right top"
              at="right bottom"
              of=".dx-datagrid-column-chooser-button"
            />

            <ColumnChooserSearch
              enabled={searchEnabled}
              editorOptions={searchEditorOptions}
            />

            <ColumnChooserSelection
              allowSelectAll={allowSelectAll}
              selectByClick={selectByClick}
              recursive={recursive}
            />
          </ColumnChooser>
          <LoadPanel enabled={true} />
          <Export enabled={true} allowExportSelectedData={true} />
          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={50} />
        </DataGrid>
      </Grid>
    </Container>
  );
}
